import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Container, Table, Spinner, Form } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DataContext } from '../../adapter';
import { modalSuccessClaimsCreateComponent } from '../components';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
    ClaimCreateService,
    ClaimSaveService,
    ClaimDocumentDeleteService,
    ClaimDocumentFileDownloadService,
    ClaimFileGetSignedUrlService,
    ClaimFileUploadService,
    ClaimGenerateUuidServices
} from '../../domain';
import { fileTypeFromBuffer } from 'file-type';

const StyledContainer = styled(Container)`
    font-family: 'Montserrat', sans-serif;
    color: rgba(41, 37, 97, 1);
    background: rgb(234, 222, 208, 1);
    padding: 20px 20%;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 100%;
        padding: 2% 10%;
    }
`;

const Title = styled.h1`
    font-size: 42px;
    font-weight: 700;
`;

const Description = styled.p`
    font-size: 22px;
    font-weight: 500;
`;

const StyledDescription = styled.p`
    font-style: italic;
    font-size: 14px;
    color: black;
    display: none;
    position: absolute;
    background: rgba(255, 255, 255, 1);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 450px;
    z-index: 100;
    top: -60px;
    left: -220px;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 300px;
        left: -200px;
        top: -80px;
    }
`;

const StyledSubmitButton = styled(Button)`
    background-color: rgba(176, 17, 22, 1);
    max-width: fit-content;
    padding: 5px 40px;
    border-radius: 25px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: white;
    text-align: center;

    @media (min-width: 300px) and (max-width: 500px) {
        font-size: 16px;
        padding: 5px 20px;
    }
`;

const StyledSubmitButton2 = styled(Button)`
    background-color: rgba(176, 17, 22, 1);
    max-width: fit-content;
    padding: 5px 40px;
    border-radius: 25px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: white;
    text-align: center;

    @media (min-width: 300px) and (max-width: 500px) {
        font-size: 16px;
        padding: 5px 20px;
    }
`;

const StyledTable = styled(Table)`
    background-color: #b30000;
    padding: 5px 40px;
    // font-weight: 700;
    font-size: 18px;
    color: white;
    // text-align: center;
`;

const Loading = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
`;

const HiddenFileInput = styled.input`
    display: none;
`;

const StyledButton = styled.label`
    background-color: #007bff;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    &:hover {
        background-color: #0056b3;
    }
`;

const InfoContainer = styled.div`
    position: relative;
    display: inline-block;
    cursor: pointer;

    &:hover .info-description {
        display: block;
    }
`;

const SubDescription = styled.p`
    font-size: 14px;
    color: black;
`;

const MySwal = withReactContent(Swal);

export default function Documents() {
    const navigate = useNavigate();
    const { claimsData, updateClaimsData, clearClaimsData } = DataContext();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [fileCollection, setFileCollection] = useState([]);
    const [fileDataCollection, setFileDataCollection] = useState([]);
    const [fileTemporaryId, setFileTemporaryId] = useState(null);

    const _ClaimSaveService = new ClaimSaveService();
    const _ClaimCreateService = new ClaimCreateService();
    const _ClaimDocumentDeleteService = new ClaimDocumentDeleteService();
    const _ClaimDocumentFileDownloadService = new ClaimDocumentFileDownloadService();
    const _ClaimFileGetSignedUrlService = new ClaimFileGetSignedUrlService();
    const _ClaimFileUploadService = new ClaimFileUploadService();
    const _ClaimGenerateUuidService = new ClaimGenerateUuidServices();

    const validateMimeType = async (file) => {
        const allowedMimeTypes = {
            // images
            jpg: ['image/jpeg'],
            jpeg: ['image/jpeg'],
            png: ['image/png'],
            // docs
            pdf: ['application/pdf'],
            docx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
            // video
            mp4: ['video/mp4'],
            // mpg: ['video/mpeg'],
            // mov: ['video/quicktime'],
            avi: ['video/vnd.avi', 'video/avi']
        };

        if (file) {
            const buffer = await file.arrayBuffer();
            const { ext, mime } = (await fileTypeFromBuffer(buffer)) || {};

            console.log('from library: -> ', file.name, 'ext:', ext, 'mime:', mime);
            console.log('from browser: -> ', file.name, 'ext:', file.name.split('.').pop(), 'mime:', file.type);

            const fileExt = file.name.split('.').pop();

            // created a sole condition for the jpeg images. due to the library reads its extension as jpg. because jpg and jpeg is the same file type.
            if (ext === 'jpg' && mime === 'image/jpeg') {
                return true;
            }

            if (ext === fileExt && allowedMimeTypes[ext]?.includes(mime)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    const validateSize = (file) => {
        const maxFileSize = 314572800; // 300 mb converted in bytes
        const fileSize = file.size; // bytes

        if (file && fileSize <= maxFileSize) {
            return true;
        } else {
            return false;
        }
    };

    const handleFileChange = async (evt, mtnDocumentTypeId, documentDesc, documentId, docIndex) => {
        setLoading(true);
        const selectedFiles = Array.from(evt.target.files);

        for (let i = 0; i < selectedFiles.length; i++) {
            const file = selectedFiles[i];
            const isValidFile = await validateMimeType(file);
            const isSizeValid = validateSize(file);

            if (!isValidFile) {
                MySwal.fire({
                    html: (
                        <div style={{ padding: '50px' }}>
                            <p>
                                The <b>{file.name}</b> file type you are trying to upload is not allowed. Please check
                                the file format and try again.
                            </p>
                        </div>
                    ),
                    showConfirmButton: false,
                    showCloseButton: true,
                    customClass: {
                        popup: 'my-popup',
                        closeButton: 'my-close-button'
                    },
                    backdrop: `
                    rgba(159, 159, 159, 0.5)
                `,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });

                document.getElementById(`fileInput_${documentId}`).value = '';
                setLoading(false);
                break;
            }

            if (!isSizeValid) {
                MySwal.fire({
                    html: (
                        <div style={{ padding: '50px' }}>
                            <p>
                                The <b>{file.name}</b> file size you are trying to upload exceeded the maximum 300mb
                                file size allowed.
                            </p>
                        </div>
                    ),
                    showConfirmButton: false,
                    showCloseButton: true,
                    customClass: {
                        popup: 'my-popup',
                        closeButton: 'my-close-button'
                    },
                    backdrop: `
                    rgba(159, 159, 159, 0.5)
                `,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });

                document.getElementById(`fileInput_${documentId}`).value = '';
                setLoading(false);
                break;
            }
            const fileExists = fileCollection.find(
                (item) => item.name === file.name && item.mtnDocumentTypeId === mtnDocumentTypeId
            );

            const existsInUploadedDocs = formData[docIndex]?.attachedDocuments.find(
                (item) => item.documentName === file.name && item.mtnDocumentTypeId === mtnDocumentTypeId
            );
            // console.log('uploaded documents:', existsInUploadedDocs);

            if (fileExists || existsInUploadedDocs) {
                MySwal.fire({
                    html: (
                        <div style={{ padding: '50px' }}>
                            <p>
                                File <b>{file.name}</b> is already uploaded in the <b>{documentDesc}</b> class.
                            </p>
                        </div>
                    ),
                    showConfirmButton: false,
                    showCloseButton: true,
                    customClass: {
                        popup: 'my-popup',
                        closeButton: 'my-close-button'
                    },
                    backdrop: `
                    rgba(159, 159, 159, 0.5)
                `,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
                document.getElementById(`fileInput_${documentId}`).value = '';
                setLoading(false);
                break;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                const downloadUrl = URL.createObjectURL(file);
                const fileId = Math.random().toString(36).substring(2, 9);

                const fileDetails = {
                    name: file.name,
                    type: file.type,
                    size: `${(file.size / 1024).toFixed(2)} kB`,
                    // base64: base64String,
                    base64: '',
                    file: {},
                    mtnDocumentTypeId: mtnDocumentTypeId,
                    id: null,
                    // fileId: Math.random().toString(36).substring(2, 9),
                    fileId: fileId,
                    url: downloadUrl
                };

                const fileData = {
                    fileId: fileId,
                    file: file,
                    name: file.name,
                    type: file.type,
                    mtnDocumentTypeId: mtnDocumentTypeId
                };

                setFileCollection((prevFileData) => [...prevFileData, fileDetails]);
                setFileDataCollection((prevFileData) => [...prevFileData, fileData]);
            };
            reader.readAsDataURL(file);
            document.getElementById(`fileInput_${documentId}`).value = '';

            await uploadFileToS3(file, fileTemporaryId, mtnDocumentTypeId);
            setLoading(false);
        }
    };

    const uploadFileToS3 = async (file, claimId, documentTypeId) => {
        const MAX_RETRIES = 3;
        const claimDirectory = `claims-${claimId}`;
        const documentDirectory = `document-${documentTypeId}`;
        const key = `${claimDirectory}/${documentDirectory}/${file.name}`;
        const contentType = file.type;

        let attempt = 0;
        let success = false;

        while (attempt < MAX_RETRIES && !success) {
            try {
                const s3Url = await _ClaimFileGetSignedUrlService.execute({ key, contentType });

                if (!s3Url?.presignedUrl) {
                    throw new Error('No Presigned URL Available...');
                }

                const uploadFile = await _ClaimFileUploadService.execute({
                    requestUrl: s3Url.presignedUrl,
                    contentType,
                    file
                });
                console.log('uploadFile: ', uploadFile);
                if (uploadFile.status === 200) {
                    success = true;
                    console.log(`Upload succeeded for ${file.name}`);
                } else {
                    throw new Error(`Upload failed with status ${uploadFile.status}`);
                }
            } catch (err) {
                attempt++;
                console.warn(`Attempt ${attempt} failed for ${file.name}:`, err);
                if (attempt === MAX_RETRIES) {
                    Swal.fire({
                        text: `Upload failed for ${file.name} after ${MAX_RETRIES} attempts.`,
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'my-popup',
                            confirmButton: 'my-confirm-button',
                            cancelButton: 'my-cancel-button'
                        }
                    });
                    return false;
                }
            }
        }

        return success;
    };

    const handleSubmit = async (event) => {
        try {
            event.preventDefault();
            console.log('formData before submit: ', formData);

            const mapped = Object.values(formData).map((item) => {
                //  Validation inside the map
                if (!Array.isArray(item.attachedDocuments)) {
                    console.error('Expected attachedDocuments to be an array:', item.attachedDocuments);
                }

                return {
                    ...item,
                    status:
                        item.attachedDocuments?.length ||
                        fileCollection.filter((item1) => item1.mtnDocumentTypeId === item.mtnDocumentTypeId)?.length
                            ? 'For Review'
                            : 'Pending',
                    attachedDocuments: [
                        ...(item.attachedDocuments || []), // fallback to empty array
                        ...fileCollection
                            .filter((item1) => item1.mtnDocumentTypeId === item.mtnDocumentTypeId)
                            .map((docfile) => ({
                                ...docfile,
                                lastUpdateBy: !claimsData?.claimsPayload?.id ? null : 'client'
                            }))
                    ]
                };
            });

            console.log('mapped documents', mapped);
            // console.log('has attachments: ', mapped.filter(item => !item.attachedDocuments.length)?.length);

            updateClaimsData({
                ...claimsData,
                kycFilledUp: true
            });

            const middleName = claimsData?.claimsPayload?.customerDetails?.middleName;
            const name = `${claimsData.claimsPayload.customerDetails.firstName}${
                middleName ? ' ' + middleName + ' ' : ' '
            }${claimsData.claimsPayload.customerDetails.lastName}`;
            const setPayload = {
                ...claimsData.claimsPayload,
                claimItems: claimsData.claimsPayload.claimItems.map((claimitem) => ({
                    ...claimitem,
                    lastUpdateBy: !claimsData?.claimsPayload?.id ? null : 'client'
                })),
                claimDocuments: mapped,
                customerDetails: {
                    ...claimsData.claimsPayload.customerDetails,
                    fullName: name,
                    displayName: name,
                    lastUpdateBy: !claimsData?.claimsPayload?.id ? null : 'client'
                },
                status: mapped?.filter((item) => !item?.attachedDocuments?.length)?.length ? 'Pending' : 'For Review',
                lastUpdateBy: !claimsData?.claimsPayload?.id ? null : 'client',                
                ...(!claimsData?.claimsPayload?.id && { remarks: 'Draft' }),
                fileTemporaryId
            };
            console.log(setPayload);

            setLoading(true);

            let response;
            if (!claimsData?.claimsPayload?.id) {
                response = await _ClaimCreateService.execute(setPayload);
            } else {
                response = await _ClaimSaveService.execute(setPayload);
            }

            if (!response.claim) {
                Swal.fire({
                    text: 'Sorry. Something went wrong. Please try again later.',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                return;
            }

            setFormData({ ...formData, claimsSubmitSuccess: true });

            const refNo = response?.claim?.claimResult?.refNo ?? '00000000';
            modalSuccessClaimsCreateComponent(refNo, navigate, clearClaimsData);
            clearClaimsData();
            setLoading(false);
        } catch (error) {
            console.log('error in document uploading: ', error);
            Swal.fire({
                text: 'Sorry. Something went wrong. Please try again later.',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
        }
    };

    const removeFile = async (file) => {
        const filterFiles = fileCollection.filter((item) => item.fileId !== file.fileId);
        setFileCollection(() => [...filterFiles]);
        console.log(fileCollection);

        const filterFileData = fileDataCollection.filter((item) => item.fileId !== file.fileId);
        setFileDataCollection(() => [...filterFileData]);
    };

    const deleteFile = async (s3UploadedDocs, index) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Delete Submitted Document?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            customClass: {
                popup: 'my-popup',
                confirmButton: 'my-confirm-button',
                cancelButton: 'my-cancel-button'
            }
        })
            .then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true);

                    // trigger document deletion
                    const response = await _ClaimDocumentDeleteService.execute({ id: s3UploadedDocs.id });

                    if (!response.deletedClaimDocument?.length) {
                        Swal.fire({
                            text: 'Sorry. Something went wrong. Please try again later.',
                            icon: 'warning',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'my-popup',
                                confirmButton: 'my-confirm-button',
                                cancelButton: 'my-cancel-button'
                            }
                        });
                        setLoading(false);
                        return;
                    }

                    const data = claimsData.claimsPayload.claimDocuments;
                    const newClaimDocuments = Object.fromEntries(
                        Object.entries(data).map(([key, value]) => [
                            key,
                            {
                                ...value,
                                attachedDocuments: value.attachedDocuments.filter((doc) => doc.id !== s3UploadedDocs.id)
                            }
                        ])
                    );

                    if (newClaimDocuments) {
                        const toArray = Object.values(newClaimDocuments).map((item) => item);

                        const newClaimsData = {
                            ...claimsData,
                            claimsPayload: {
                                ...claimsData.claimsPayload,
                                claimDocuments: toArray
                            }
                        };
                        updateClaimsData(newClaimsData);
                        setFormData({ ...newClaimsData.claimsPayload.claimDocuments });

                        console.log('submitted document deleted.', formData);

                        // check if the document types per claim type has one empty attachedDocuments array. (if yes update the claims as pending if not do nothing)
                        const hasEmptyAttachedDocuments = Object.values(formData).filter(
                            (item) => !item.attachedDocuments.length
                        );
                        console.log('hasEmptyAttachedDocuments: ', hasEmptyAttachedDocuments);

                        if (hasEmptyAttachedDocuments && claimsData.claimsPayload.status === 'For Review') {
                            const setPayload = {
                                ...claimsData.claimsPayload,
                                claimDocuments: toArray,
                                status: toArray?.filter((item) => !item?.attachedDocuments?.length)?.length
                                    ? 'Pending'
                                    : 'For Review'
                            };
                            console.log(setPayload);

                            await _ClaimSaveService.execute(setPayload);
                        }
                    }

                    Swal.fire({
                        text: 'Submitted Document Deleted',
                        icon: 'success',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'my-popup',
                            confirmButton: 'my-confirm-button',
                            cancelButton: 'my-cancel-button'
                        }
                    });
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    text: 'Sorry. Something went wrong. Please try again later.',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
            });
    };

    const downloadFile = async (event) => {
        try {
            const payload = {
                directoryName: event.documentDir,
                documentName: event.documentName
            };
            setLoading(true);
            const file = await _ClaimDocumentFileDownloadService.execute(payload);

            if (!file.file) {
                Swal.fire({
                    text: 'Sorry. Something went wrong. Please try again later.',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                return;
            }

            const link = document.createElement('a');
            link.href = file.file;
            // link.target = '_blank';
            link.download = event.documentName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            console.log('file', file);
            setLoading(false);

            console.log(file);
            setLoading(false);
        } catch (error) {
            console.log(error);
            Swal.fire({
                text: 'Sorry. Something went wrong. Please try again later.',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
        }
    };

    const generateUuid = async () => {
        const response = await _ClaimGenerateUuidService.execute({});
        console.log('generateUuid', response);
        setFileTemporaryId(response?.uuid);
    };

    useEffect(() => {
        if (Object.keys(claimsData).length) {
            setFormData({ ...claimsData.claimsPayload.claimDocuments });
            generateUuid();

            if (!claimsData?.claimsPayload) {
                navigate('/home');
                clearClaimsData();
            }

            if (!claimsData?.claimsPayload?.customerDetails?.customerId && !claimsData.kycFilledUp) {
                navigate('/home');
            }
        } else {
            navigate('/home');
        }
    }, []);

    return (
        <>
            {loading && (
                <Loading>
                    <Spinner animation="border" variant="light" />
                </Loading>
            )}

            <StyledContainer fluid>
                <Form onSubmit={(event) => handleSubmit(event)}>
                    <Row className="pt-4">
                        <Title>File a Claim</Title>
                    </Row>
                    <Row className="pt-2">
                        <Col>
                            <Description className="mb-0">
                                Please provide the following required documents:
                                <InfoContainer>
                                    <i className="bi bi-info-circle" style={{ padding: '8px', fontSize: '20px' }}></i>
                                    <StyledDescription className="info-description">
                                        Pakigamit ang table sa ibaba upang ibigay ang mga sumusunod na kinakailangang
                                        dokumento.
                                    </StyledDescription>
                                </InfoContainer>
                            </Description>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <SubDescription>
                                We can accept files up to 300 MB in the following formats: <br />
                                JPG/JPEG/PNG, PDF/DOCX,MP4/AVI
                            </SubDescription>
                        </Col>
                    </Row>

                    <Row className="pt-2">
                        <Col>
                            <StyledTable striped bordered hover>
                                <thead>
                                    <tr>
                                        <th width="50%">Required Documents</th>
                                        <th width="">Action</th>
                                        <th width="40%">File Preview</th>
                                        {!!Object.values(formData)?.filter(
                                            (item1) => item1.attachedDocuments?.filter((item2) => item2.remarks).length
                                        ).length && <th>Remarks</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {claimsData?.claimsPayload?.claimDocuments &&
                                        claimsData.claimsPayload.claimDocuments.map((item, index) => {
                                            return (
                                                <tr key={'policyItem_' + index}>
                                                    <td>{item.documentDesc}</td>
                                                    <td>
                                                        <StyledButton htmlFor={`fileInput_${item.id}`}>
                                                            Upload
                                                        </StyledButton>
                                                        <HiddenFileInput
                                                            type="file"
                                                            multiple
                                                            size="sm"
                                                            id={`fileInput_${item.id}`}
                                                            name={`name_${item.id}`}
                                                            onChange={(evt) =>
                                                                handleFileChange(
                                                                    evt,
                                                                    item.mtnDocumentTypeId,
                                                                    item.documentDesc,
                                                                    item.id,
                                                                    index
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                    <td style={{ paddingLeft: '20px' }}>
                                                        {fileCollection &&
                                                            fileCollection.map((fileItem) => {
                                                                if (
                                                                    fileItem.mtnDocumentTypeId ===
                                                                    item.mtnDocumentTypeId
                                                                ) {
                                                                    return (
                                                                        <li key={fileItem.fileId}>
                                                                            {fileItem.type.split('/')[0] === 'image' ? (
                                                                                <span>
                                                                                    <a
                                                                                        href={fileItem.url}
                                                                                        target="_blank"
                                                                                        className="me-3"
                                                                                    >
                                                                                        {fileItem.name}
                                                                                    </a>
                                                                                    <a
                                                                                        href="#"
                                                                                        className="text-danger"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            removeFile(fileItem);
                                                                                        }}
                                                                                    >
                                                                                        remove
                                                                                    </a>
                                                                                </span>
                                                                            ) : (
                                                                                <span>
                                                                                    <a
                                                                                        className="me-3"
                                                                                        href={fileItem.url}
                                                                                        download={fileItem.url}
                                                                                    >
                                                                                        {fileItem.name}
                                                                                    </a>
                                                                                    <a
                                                                                        href="#"
                                                                                        className="text-danger"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            removeFile(fileItem);
                                                                                        }}
                                                                                    >
                                                                                        remove
                                                                                    </a>
                                                                                </span>
                                                                            )}
                                                                            <br />
                                                                        </li>
                                                                    );
                                                                } else {
                                                                    return null;
                                                                }
                                                            })}
                                                        {!!item?.attachedDocuments?.length && (
                                                            <div>
                                                                <hr />
                                                                <small>Submitted Documents</small>
                                                                {item.attachedDocuments.map((s3UploadedDocs) => {
                                                                    return (
                                                                        <li key={`s3Uploaded_${s3UploadedDocs.id}`}>
                                                                            <span>
                                                                                <a
                                                                                    href="#"
                                                                                    className="me-3"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        downloadFile(s3UploadedDocs);
                                                                                    }}
                                                                                >
                                                                                    {s3UploadedDocs.documentName}
                                                                                </a>
                                                                                <a
                                                                                    href="#"
                                                                                    className="text-danger"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        deleteFile(
                                                                                            s3UploadedDocs,
                                                                                            index
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    remove
                                                                                </a>
                                                                            </span>

                                                                            <br />
                                                                        </li>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </td>
                                                    {!!Object.values(formData)?.filter(
                                                        (item1) =>
                                                            item1.attachedDocuments?.filter((item2) => item2.remarks)
                                                                .length
                                                    ).length === true && <td>{item.attachedDocuments[0]?.remarks}</td>}
                                                </tr>
                                            );
                                        })}
                                    {!claimsData?.claimsPayload?.claimDocuments?.length && (
                                        <tr className="text-center">
                                            <td colSpan="7">No data available.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </StyledTable>
                        </Col>
                    </Row>

                    <Row>
                        <div className="gap-2 justify-content-left mt-2">
                            <StyledSubmitButton
                                variant="danger me-2"
                                onClick={() => {
                                    if (!claimsData.claimsPayload.customerDetails.customerId) {
                                        navigate('/kyc');
                                    } else {
                                        navigate('/details');
                                    }
                                }}
                            >
                                PREVIOUS
                            </StyledSubmitButton>
                            <StyledSubmitButton2 type="submit" variant="danger">
                                SUBMIT
                            </StyledSubmitButton2>
                        </div>
                    </Row>
                </Form>
            </StyledContainer>
        </>
    );
}
